import React from 'react';
import './boot-shell.sass';
import Loader from 'shared-components/helper-components/loader/loader';
import LayoutShell from '@pano-project/components/Layout/MainLayout/LayoutShell';
import { getLayoutClassNames } from '@pano-project/components/Layout/MainLayout/layout-class-names';
import BootHeader from '@pano-project/components/CashierHeader/BootHeader';
import { useBootHeaderSettings } from '@pano-project/components/CashierHeader/useBootHeaderSettings';
import { bootThemeVariables } from '@pano-project/variables/boot-theme-variables';

interface BootShellProps {
  text?: string | false;
  showLoaderIcon?: boolean;
}

const BootShell = (props: BootShellProps) => {
  const { shouldRender, headerStyle, layout, appearanceMode } = useBootHeaderSettings();

  if (!shouldRender) return <Loader {...props} />;

  bootThemeVariables.inject(appearanceMode);

  const className = `${getLayoutClassNames({
    layout,
    headerStyle,
    appearanceMode,
    showHeaderButtons: true,
  })} _boot-shell`;

  return (
    <LayoutShell className={className}>
      <BootHeader />
      <Loader {...props} />
    </LayoutShell>
  );
};

export default BootShell;
